class PasswordModal extends DetailsModal {
  constructor() {
    super();
    this.onHashChange = this.onHashChange.bind(this);

    if (this.querySelector('input[aria-invalid="true"]') || this.isRequestedByHash()) this.openModal();
  }

  connectedCallback() {
    window.addEventListener('hashchange', this.onHashChange);
  }

  disconnectedCallback() {
    window.removeEventListener('hashchange', this.onHashChange);
  }

  isRequestedByHash() {
    return Boolean(this.dataset.openHash) && window.location.hash === `#${this.dataset.openHash}`;
  }

  onHashChange() {
    if (this.isRequestedByHash()) {
      if (!this.isOpen()) this.openModal();
    } else if (this.openedByHash && this.isOpen()) {
      this.close();
    }
  }

  openModal() {
    this.opener = document.activeElement;
    this.openedByHash = this.isRequestedByHash();
    this.open({ target: this.querySelector('details') });
  }

  close(focusToggle = true) {
    super.close(focusToggle);
    // A hidden toggle can't take focus back, so return it to whatever opened the modal.
    if (focusToggle && this.summaryToggle.hidden && this.opener?.isConnected && this.opener !== document.body) {
      this.opener.focus();
    }
    this.openedByHash = false;
    // Drop the hash so a reload doesn't reopen the modal and the same link works again.
    if (this.isRequestedByHash()) history.replaceState(null, '', window.location.pathname + window.location.search);
  }
}

customElements.define('password-modal', PasswordModal);
